var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCircleX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    stroke: "#EF4452",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5828 11.2504C10.3982 11.2504 10.2136 11.18 10.0728 11.0393L4.01511 4.98157C3.73328 4.70003 3.73328 4.2434 4.01511 3.96186C4.29665 3.68003 4.75357 3.68003 5.03482 3.96186L11.0925 10.0196C11.3743 10.3011 11.3743 10.7577 11.0925 11.0393C10.9517 11.18 10.7674 11.2504 10.5828 11.2504Z",
    fill: "#EF4452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52511 11.2502C4.3405 11.2502 4.15588 11.1798 4.01511 11.0391C3.73328 10.7575 3.73328 10.3009 4.01511 10.0194L10.0728 3.96137C10.3543 3.67954 10.8113 3.67954 11.0925 3.96137C11.3743 4.24291 11.3743 4.69954 11.0925 4.98108L5.03482 11.0388C4.89405 11.1795 4.70944 11.2499 4.52482 11.2499L4.52511 11.2502Z",
    fill: "#EF4452"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5385,
    height: 11.5385,
    fill: "white",
    transform: "translate(1.73077 1.73096)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCircleX);
export default __webpack_public_path__ + "static/media/daily_circle_x.b6fbc9d76a1eab36ac952dcdfe4e72a9.svg";
export { ForwardRef as ReactComponent };